import { useParams } from "react-router-dom";
import { IssuePage } from "../IssuePages/IssuePage";
import { useEffect, useRef, useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import { useDispatch, useSelector } from "react-redux";
import { DocUpload } from "../../../Pages/RequestSupport/AllIssues/Issues.config";
import { ErrorToast, SuccessToast } from "../../ToastComponent/RectHotToast";
import Input from "../../Input/Input";
import Button from "../../Button/Button";
import DocumentuploadSection from "../../../Templets/DocumentuploadSection/DocumentuploadSection";
import { getUserID } from "../../../../CommonFunction/GetUserInfo";
import "./SingleIssue.scss";
import socket from "../../../../CommonFunction/SocketClient";
import { IsoToDateWithTime } from "../../../../CommonFunction/IsoDateTime";
import { editIssue, getChatByIssueId, getIssueById, sendChat } from "../../../../Utils/AllPagesQuriesAndMutations";
type RouteParams = {
  id: string;
};

interface RootState {
  MessageStoreReducer: {
    messages: any[]; // Replace with the actual type of the messages
  };
  // ... other state slices
}
export const SingleIssue = ({ fielddata, TypeOfPortal, settoggle }) => {
  let { id } = useParams<RouteParams>();
  const [status, setStatus] = useState<string>("");
  const [AssignTo, setAssignTo] = useState<string>("");
  const typingAreaRef = useRef<HTMLDivElement>(null);

  const { data: chatData, refetch } = useQuery(getChatByIssueId, {
    variables: { Request_Support_Id: id ? id : fielddata ? fielddata._id : "" },
  });
  const [EditIssue] = useMutation(editIssue);
  useEffect(() => {
    refetch({ Request_Support_Id: id ? id : fielddata ? fielddata._id : "" });
  }, []);
  useEffect(() => {
    // socket.on("New Message", (chat) => {
    //   dispatch({ type: "NewChat", payload: chat });
    // });
  }, []);

  const [sendMSG] = useMutation(sendChat);
  const FormData = useSelector((store: any) => store.FormFieldData);
  let [msgData, setmsgData] = useState<string>("");
  const msgDataRef = useRef(msgData);
  const message = useSelector((store: RootState) => store.MessageStoreReducer.messages);
  const [messageData, setmessageData] = useState(chatData?.getChatIDwithTicketId);
  const { data } = useQuery(getIssueById, {
    variables: {
      id: id ? id : fielddata ? fielddata._id : "",
    },
  });
  useEffect(() => {
    msgDataRef.current = msgData;
  }, [msgData]);

  useEffect(() => {
    setmessageData(message);
  }, [message]);
  const chatContainerRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [messageData]);
  useEffect(() => {
    if (chatData?.getChatIDwithTicketId) {
      // setmessageData(chatData.getChatIDwithTicketId);
      dispatch({
        type: "PreviousChat",
        payload: chatData.getChatIDwithTicketId,
      });
    }
  }, [chatData]);
  const handleClick = () => {
    let data = {
      Doc_1: "",
      Message: msgDataRef.current,
      Request_Support_Id: id ? id : fielddata?._id ? fielddata._id : "",
    };
    if (FormData?.fielddata?.Files && Object.keys(FormData?.fielddata?.Files)?.length) {
      data.Doc_1 = FormData?.fielddata?.Files.Attachment;
    }
    sendMSG({
      variables: {
        createInput: data,
      },
    })
      .then((res) => {
        // socket.emit("NewChat", {
        //   Request_Support_Id: res.data.createChat.Request_Support_Id,
        //   Complete_Chat: res.data.createChat,
        // });
        /* If socket get start I need to comment or remove this dispatch. */
        // dispatch({
        //   type: "NewChat",
        //   payload: {
        //     ...res.data.createChat,
        //     UserData: res.data.createChat.UserId,
        //   },
        // });
        setmsgData("");
      })
      .catch((err) => ErrorToast(err.message));
  };
  const handleStatusSubmit = () => {
    EditIssue({
      variables: {
        id: fielddata?._id,
        userInput: { Status: status },
      },
    })
      .then((res) => {
        SuccessToast("Success");
        dispatch({ type: "Refetch", payload: true });

        setStatus("");
        settoggle(false);
      })
      .catch((err) => ErrorToast(err.message));
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleClick();
    }
  };
  useEffect(() => {
    const enterKey = typingAreaRef.current;
    if (enterKey) {
      enterKey.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          handleKeyDown(e);
        }
      });

      // Cleanup function
      return () => {
        enterKey.removeEventListener("keydown", handleKeyDown);
      };
    }
  }, []);

  return (
    <div className={`singleIssueContainer ${fielddata?._id ? "modalCommentContainer" : ""}`}>
      {data?.getRequestSupportByID && (
        <IssuePage
          data={data?.getRequestSupportByID}
          title={(data?.getRequestSupportByID && data?.getRequestSupportByID[0].Unique_Id) || ""}
          modal={fielddata?._id ? true : false}
        />
      )}
      {/* <IssuePage data={[Issues[0]]} title={id || ""} /> */}
      {fielddata?._id && !(TypeOfPortal === "View") && (
        <div className="statusAndAssignContainer">
          <div className="statusAndAssign">
            <Input
              EMTQuery=""
              checked={""}
              InputConfig=""
              value={status}
              type={"text"}
              disabled={false}
              handleInputChange={(evt) => {
                setStatus(evt.target.value);
                // HandleInputChange(evt, el.id);
              }}
              handleBlur={() => { }}
              name={"Status"}
              TypeOfPortal={""}
              modalform={true}
              Section_Type=""
              className=""
              touched={false}
              error={""}
              dropdowndata={["Unread", "Open", "Hold", "Closed"]}
              label=""
              max={Infinity}
              JurnalDropdown={false}

              transactions={false}
              PaymentProcess=""
              notSearchable=""

              onFocus={() => { }}
            />
            <Input
              EMTQuery=""
              checked={""}
              InputConfig=""
              value={AssignTo}
              type={"text"}
              disabled={false}
              handleInputChange={(evt) => {
                setAssignTo(evt.target.value);
                // HandleInputChange(evt, el.id);
              }}
              handleBlur={() => { }}
              name={"Assign_To"}
              TypeOfPortal={""}
              modalform={true}
              Section_Type=""
              className=""
              touched={false}
              error={""}
              dropdowndata={["Unread", "Open", "Hold", "Close"]}
              label=""
              max={Infinity}
              JurnalDropdown={false}

              transactions={false}
              PaymentProcess=""
              notSearchable=""

              onFocus={() => { }}
            />
            <Button action={handleStatusSubmit} text="Submit" name="AddRow" type="" children="" disabled={false} />
          </div>
        </div>
      )}
      {!(TypeOfPortal === "View") && (
        <div className={`CommentContainer `} ref={chatContainerRef}>
          <div className="messages">
            {messageData?.map((el) => {
              return (
                <div className={`singleMessage ${el.UserId === getUserID() ? "selfMsg" : "otherMsg"}`}>
                  <div>{el.Message}</div>
                  <div>
                    <p>{el.Status}</p>
                    <p>{IsoToDateWithTime(el.createdAt)}</p>
                    <span>{el.UserName}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
      {!(TypeOfPortal === "View") && (
        <div className="TypingArea" ref={typingAreaRef}>
          <div>
            <Input
              EMTQuery=""
              checked={""}
              InputConfig=""
              value={msgData}
              type={"textarea"}
              disabled={false}
              handleInputChange={(evt) => {
                setmsgData(evt.target.value);
                // HandleInputChange(evt, el.id);
              }}
              handleBlur={() => { }}
              name={"Comment"}
              TypeOfPortal={""}
              modalform={true}
              Section_Type=""
              className=""
              touched={false}
              error={""}

              label=""
              max={Infinity}
              JurnalDropdown={false}

              transactions={false}
              PaymentProcess=""
              notSearchable=""

              onFocus={() => { }}
            />
          </div>
          <div>
            <DocumentuploadSection
              fielddata={fielddata}
              allFieldsData={{}}
              data={DocUpload}
              TypeOfPortal={"Request Support"}
              LoadForm={true}
              values={fielddata}
            />
          </div>
          {/* <button onClick={handleClick}>Send</button> */}
          <Button action={handleClick} text="Send" name="AddRow" type={null} children={null} disabled={false} />
        </div>
      )}
    </div>
  );
};
